import { render, staticRenderFns } from "./messengerContactInfo.vue?vue&type=template&id=d799614e&scoped=true&"
import script from "./messengerContactInfo.vue?vue&type=script&lang=js&"
export * from "./messengerContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./messengerContactInfo.vue?vue&type=style&index=0&id=d799614e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d799614e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VBtn,VIcon,VImg,VSheet})
